import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination } from "swiper/modules";
import { SliderData } from "../../fakeData/Slider";
import { Link } from "react-router-dom";

function Slider() {
  return (
    <Swiper
      spaceBetween={30}
      loop={true}
      centeredSlides={true}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      modules={[Autoplay, Pagination]}
      className="mySwiper"
    >
      {SliderData.map((data, index) => {
        return (
          <SwiperSlide
            key={index}
            className="rounded-lg relative h-full overflow-hidden"
          >
            {/* Background Image */}
            <div className="text-sm text-gray-600 hover:text-emerald-dark">
              <span
                style={{
                  boxSizing: "border-box",
                  display: "block",
                  overflow: "hidden",
                  width: "initial",
                  height: "initial",
                  background: "none",
                  opacity: "1",
                  border: "0px",
                  margin: "0px",
                  padding: "0px",
                  position: "relative",
                }}
              >
                <span
                  style={{
                    boxSizing: "border-box",
                    display: "block",
                    width: "initial",
                    height: "initial",
                    background: "none",
                    opacity: "1",
                    border: "0px",
                    margin: "0px",
                    padding: "42.1053% 0px 0px",
                  }}
                ></span>
                <img
                  alt="Quality Freshness Guaranteed!"
                  sizes="100vw"
                  src={data.img}
                  decoding="async"
                  data-nimg="responsive"
                  className="object-cover"
                  style={{
                    position: "absolute",
                    inset: "0px",
                    boxSizing: "border-box",
                    padding: "0px",
                    border: "none",
                    margin: "auto",
                    display: "block",
                    width: "0px",
                    height: "0px",
                    minWidth: "100%",
                    maxWidth: "100%",
                    minHeight: "100%",
                    maxHeight: "100%",
                  }}
                />
              </span>
            </div>

            {/* Overlay Text */}
            <div className="absolute top-0 left-0 z-10 flex flex-col w-full h-full items-start justify-center">
  <div className="pl-4 pr-12 sm:pl-10 sm:pr-16 w-10/12 lg:w-8/12 xl:w-7/12">
    {/* Title: no bg, just shadow */}
    <h1
        className={`mb-2 text-xl sm:text-lg md:text-2xl lg:text-3xl font-bold ${
          data.name === "Chemicals" ? "text-white" : "text-gray-800" } drop-shadow-md break-words`}>
        {data.name}
    </h1>

    {/* MOBILE: clamped version (visible on small screens only) */}
    <div className="md:hidden">
      <div
        className="overflow-hidden"
        style={{
          display: '-webkit-box',
          WebkitLineClamp: 4,       // show up to 4 lines on mobile
          WebkitBoxOrient: 'vertical'
        }}
      >
        <span className="text-base leading-6 text-white drop-shadow-md break-words whitespace-pre-line bg-black/40 px-2 py-1 rounded-md inline-block">
          {data.description_md ? data.description_md : data.description}
        </span>
      </div>
    </div>

    {/* DESKTOP/TABLET: full text (visible md and up) */}
    <div className="hidden md:block">
      <p className="text-base leading-6 text-white drop-shadow-md break-words whitespace-pre-line bg-black/40 px-2 py-1 rounded-md inline-block max-w-full md:max-w-lg">
        {data.description}
      </p>
    </div>
  </div>
</div>


          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}

export default Slider;